import DistanceLearning from '@/views/distanceLearning/distanceLearningPage.vue'

export default [
  {
    path: '/distanceLearning',
    name: 'Distance Learning',
    component: DistanceLearning,
    meta: {
      title: 'Distance Learning Hours',
      requiresAuth: true,
      authorizedUsers: [6],
    },
  },
]
